(() => {
  const syncFooter = (footer) => {
    const desktop = window.matchMedia('(min-width: 900px)').matches;
    footer.querySelectorAll('[data-footer-disclosure]').forEach((disclosure) => {
      disclosure.open = desktop || disclosure.hasAttribute('data-mobile-open');
      const summary = disclosure.querySelector('summary');
      if (!summary) return;
      if (desktop) {
        summary.setAttribute('tabindex', '-1');
        summary.setAttribute('aria-disabled', 'true');
      } else {
        summary.removeAttribute('tabindex');
        summary.removeAttribute('aria-disabled');
      }
    });
  };

  const initialize = () => document.querySelectorAll('[data-buddyora-footer]').forEach(syncFooter);
  initialize();
  window.matchMedia('(min-width: 900px)').addEventListener('change', initialize);
  document.addEventListener('shopify:section:load', initialize);
})();
